// ported from src/web/style/_input.scss

import {
  OL_COLOUR_BLACK_55,
  OL_COLOUR_BLACK_90,
  OL_COLOUR_TOMAHTO,
  OL_COLOUR_BLACK_4,
} from './colours';
import { MIXIN_FOCUS } from './mixins';

export const INPUT_BORDER_RADIUS = '2px';
export const INPUT_BORDER_COLOR = OL_COLOUR_BLACK_55;
export const INPUT_LABEL_SPACING = '0.3em';

export const INPUT_BOX_BORDER = {
  border: `1px solid ${INPUT_BORDER_COLOR}`,
  borderRadius: INPUT_BORDER_RADIUS,
  transition: 'border linear 0.2s, box-shadow linear 0.2s',
  boxShadow: 'inherit',
};

export const INPUT_BOX_CONTENT = {
  color: OL_COLOUR_BLACK_90,
  paddingTop: '0.6em',
  paddingRight: '0.8em',
  paddingBottom: '0.6em',
  paddingLeft: '0.8em',
  fontSize: '14px',
  lineHeight: 1.5,
};

export const INPUT_BOX = {
  ...INPUT_BOX_BORDER,
  ...INPUT_BOX_CONTENT,
  background: '#fff',
  height: 'auto',
  fontFamily: 'inherit',

  // TODO: figure out what this will cause typescript error
  // For some reason this`boxSizing` error causes typescript error when
  // this mixin is used
  //
  // Workaround: need to set the `boxSizing` when used, for example:
  // const Box = styled('div')({ ...INPUT_BOX, boxSizing: 'border-box' });
  boxSizing: 'border-box',

  '&:focus': MIXIN_FOCUS,

  '&::placeholder': {
    color: OL_COLOUR_BLACK_55,
  },
};

// TODO: port @mixin react-selectize from _input.scss

export const INPUT_LABEL = {
  display: 'block',
  fontWeight: 600,
  color: OL_COLOUR_BLACK_90,
  marginBottom: INPUT_LABEL_SPACING,
  fontSize: 'inherit',
};

export const INPUT_ERROR = {
  display: 'block',
  fontWeight: 400,
  color: OL_COLOUR_TOMAHTO,
};

export const INPUT_DESCRIPTION = {
  display: 'block',
  fontWeight: 400,
  color: OL_COLOUR_BLACK_55,

  // cancel out input-label's margin-buttom
  marginTop: `-${INPUT_LABEL_SPACING}`,
  marginBottom: INPUT_LABEL_SPACING,
};

export const INPUT_BUTTON = {
  ...INPUT_BOX,
  background: OL_COLOUR_BLACK_4,
  borderColor: INPUT_BORDER_COLOR,
  borderLeftWidth: 0,
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  borderTopRightRadius: INPUT_BORDER_RADIUS,
  borderBottomRightRadius: INPUT_BORDER_RADIUS,
  flexGrow: 0,
  flexShrink: 0,
  cursor: 'pointer',
};

export const INPUT_FIELDSET_LEGEND = {
  ...INPUT_LABEL,
  display: 'block',
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  lineHeight: 'inherit',
  border: 0,
};

export const INPUT_FIELDSET = {
  border: 0,
  margin: 0,
  padding: 0,
};

// TODO: port @mixin checkbox-error from _input.scss
// TODO: port @mixin inputs-fieldset from _input.scss
// TODO: port @mixin inputs-fieldset-legend from _input.scss
// TODO: port @mixin inputs-fieldset-label from _input.scss
